module.exports = __webpack_public_path__ + "img/ins-qrcode.ba04db2.jpg";